import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";

const styles = theme => ({
  root: {
    background: theme.palette.white,
    cursor: "pointer",
    //padding:theme.margins.xs,
    //  margin:`0 ${theme.margins.xs}px`,
    height: "auto", // Reset
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "0px 8px",
    fontSize: 16,
    border: "1px solid #dadada",
    width:130,
  },
  rootWithoutPadding: {
    background: theme.palette.white,
    cursor: "pointer",
    //padding:theme.margins.xs,
    //  margin:`0 ${theme.margins.xs}px`,
    height: "auto", // Reset
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "0px",
    minHeight: 50,
    fontSize: 16
  },
  input: {
    ...theme.typography.body1,
    lineHeight: 1,
    fontWeight: 400,
    width: "100%",
    paddingRight: 8,
    "&:focus": {
      // Show that it's not an text input
      backgroundColor: "inherit"
    }
  },
  select: {},
  display_none: {
    width: 0,
    minWidth: 0,
    maxWidth: 0,
    height: 0,
    minHeight: 0,
    maxHeight: 0,
    padding: 0,
    margin: 0
  }
});

const SelectInput = ({
  classes: { root, rootWithoutPadding, input, display_none },
  disableUnderline,
  iconComponent,
  className,
  input_class,
  type,
  ...other
}) => {
  return (
    <Input
      classes={{
        root:
          type === "icon" ? `${rootWithoutPadding} ${input_class || ""}` : root,
        input: type === "icon" ? display_none : `${input} ${input_class || ""}`
      }}
      className={className || ""}
      disableUnderline={disableUnderline}
      startAdornment={
        Boolean(iconComponent) && (
          <InputAdornment position="start">
            <div> {iconComponent} </div>
          </InputAdornment>
        )
      }
      {...other}
    />
  );
};

SelectInput.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    input: PropTypes.string.isRequired
  }),
  iconComponent: React.isValidElement,
  className: PropTypes.string
};

SelectInput.defaultProps = {
  iconComponent: null,
  disableUnderline: true
};

export default withStyles(styles)(SelectInput);

////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////

const field_styles = theme => ({
  root: {
    background: theme.palette.white,
    cursor: "pointer",
    padding: `0 ${theme.margins.xs}px`
  },
  input: {
    ...theme.typography.body1,
    lineHeight: 1,
    fontWeight: 400,
    padding: `${theme.margins.xs}px 0`,
    minWidth: 0
  },
  select: {}
});

export const SelectInputField = withStyles(styles)(
  ({ classes: { root, input }, iconComponent, input_class, ...other }) => (
    <Input
      classes={{
        root,
        input: `${input}`
      }}
      startAdornment={
        Boolean(iconComponent) && (
          <InputAdornment position="start">
            <div> {iconComponent} </div>
          </InputAdornment>
        )
      }
      {...other}
    />
  )
);

SelectInputField.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    input: PropTypes.string.isRequired
  }),
  iconComponent: React.isValidElement,
  className: PropTypes.string
};

SelectInputField.defaultProps = {
  iconComponent: null,
  disableUnderline: true
};
